import { Box } from '@mui/material'
import { Calendar as RBCalendar, dayjsLocalizer } from 'react-big-calendar'
import Event from '../../concepts/Calendar/types/Event'
import { local } from '../../lib/dayjs'
import * as styles from './styles'

import 'react-big-calendar/lib/css/react-big-calendar.css'

type DateRange = { start: Date; end: Date }

type Props = {
  events: Event[]
  loading: boolean
  defaultDate?: Date
  defaultView?: 'month' | 'week'
  onRangeChanged: (range: DateRange) => void
}

const localizer = dayjsLocalizer(local)

const Calendar = ({
  events,
  loading,
  defaultDate = new Date(),
  defaultView,
  onRangeChanged
}: Props) => {
  const handleRangeChange = (range: Date[] | DateRange) => {
    if (Array.isArray(range)) {
      onRangeChanged({ start: range[0], end: range[range.length - 1] })
    } else {
      onRangeChanged(range)
    }
  }

  const handleSelectEvent = (event: Event) => {
    window.open(event.url, '_blank')
  }

  return (
    <Box sx={styles.calendar}>
      {loading && (
        <Box sx={styles.loading}>
          <Box sx={styles.spinner} />
        </Box>
      )}
      {/* @ts-expect-error library needs update */}
      <RBCalendar
        views={['month', 'week']}
        localizer={localizer}
        defaultDate={defaultDate}
        defaultView={defaultView}
        events={events}
        onSelectEvent={handleSelectEvent}
        onRangeChange={handleRangeChange}
      />
    </Box>
  )
}

export default Calendar
